import cn from "classnames";
import React, { ReactNode, useState } from "react";
import { PanelWembii } from "../component/PanelWembii";
import Backdrop from "./Backdrop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingSpinnerWembii } from "../component/LoadingSpinnerWembii";
import { useIntl } from "react-intl";

interface Props {
  children: ReactNode;
  active: boolean;
  visible?: boolean;
  showSppiner?: boolean;
  sppinerMessage?: string;
  showError?: boolean;
  left?: boolean;
  onClose: () => void;
}

export default function SideModal(props: Props) {
  const intl = useIntl();
  const {
    children,
    active,
    onClose,
    visible = false,
    showSppiner = false,
    showError = false,
    sppinerMessage,
    left = false,
  } = props;
  const [fullScreen, setFullShow] = useState(false);

  return (
    <>
      {active && (
        <>
          {active && visible && <Backdrop onClick={onClose} />}
          <PanelWembii
            shadow
            className={cn({
              sideModalHidden: !visible,
              sideModalOn: active,
              sideModalRight: !left,
              sideModalLeft: left,
              sideModalOffLeft: left && !active,
              sideModalOffRight: !left && !active,
              fullScreenModal: fullScreen,
              sideModal: !fullScreen,
            })}
          >
            <div className="d-flex justify-content-end align-items-center mt-0 mb-1 mr-2 ml-2 px-1 py-2 pointer sticky-top side-modal-toolbar">
              <FontAwesomeIcon
                className="mr-1"
                size="lg"
                icon={
                  fullScreen ? ["fas", "compress-alt"] : ["fas", "expand-alt"]
                }
                onClick={() => setFullShow(!fullScreen)}
              />
              <FontAwesomeIcon
                icon={["fas", "times"]}
                size="lg"
                onClick={onClose}
                role="button"
                aria-label={intl.formatMessage({ id: "app.modal.close" })}
              />
            </div>

            <div className="overflow-auto h-100 position-relative">
              {showError && (
                <div className="h-100 d-flex justify-content-center align-items-center">
                  <FontAwesomeIcon
                    icon={["fas", "exclamation-circle"]}
                    className="mr-2"
                  />
                  {intl.formatMessage({ id: "app.modal.error.loading.data" })}
                </div>
              )}
              {!showError && children}
              {showSppiner && !showError && (
                <div
                  className="position-absolute d-flex flex-column justify-content-center align-items-center w-100 h-100 side-modal-loading-overlay"
                  style={{
                    top: 0,
                    left: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.85)",
                    zIndex: 10,
                  }}
                >
                  <LoadingSpinnerWembii active sppinerMessage={sppinerMessage} />
                </div>
              )}
            </div>
          </PanelWembii>
        </>
      )}
    </>
  );
}
